import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../Styles/ToggleSwitch.css'; // Import your custom CSS for styling

const ToggleSwitch = ({ onChange, isChecked, className }) => {
  // const [isChecked, setIsChecked] = useState(checked || false);

  const handleToggle = () => {
    const newCheckedState = !isChecked;
    // setIsChecked(newCheckedState);
    onChange(newCheckedState);
  };

  return (
    <label className={`toggle-switch ${className || ''}`}>
      <input
        type="checkbox"
        className="toggle-switch-checkbox"
        checked={isChecked}
        onChange={handleToggle}
      />
      <span className="toggle-switch-slider"></span>
    </label>
  );
};

ToggleSwitch.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  className: PropTypes.string,
};

export default ToggleSwitch;
